export const TRACK_RESOLVE_FAQ_OPEN = 'CS/TRACK_RESOLVE_FAQ_OPEN';
export const TRACK_RESOLVE_FAQ_LINK_CLICKED = 'CS/TRACK_RESOLVE_FAQ_LINK_CLICKED';
export const TRACK_RESOLVE_OPTION_CLICKED = 'CS/TRACK_RESOLVE_OPTION_CLICKED';
export const TRACK_RESOLVE_OPTION_CTA_CLICKED = 'CS/TRACK_RESOLVE_OPTION_CTA_CLICKED';
export const TRACK_RESOLVE_VIEW_ALL_MISSED_PAYMENTS_CLICKED = 'CS/TRACK_RESOLVE_VIEW_ALL_MISSED_PAYMENTS_CLICKED';
export const TRACK_RESOLVE_COACHING_CTA_CLICKED = 'CS/TRACK_RESOLVE_COACHING_CTA_CLICKED';
export const TRACK_RESOLVE_SPINNER_SHOWN = 'CS/TRACK_RESOLVE_SPINNER_SHOWN';
export const TRACK_RESOLVE_HELP_ARTICLE_CLICKED = 'CS/TRACK_RESOLVE_HELP_ARTICLE_CLICKED';
export const TRACK_RESOLVE_LANDING_SCREEN_CTA_CLICKED = 'CS/TRACK_RESOLVE_LANDING_SCREEN_CTA_CLICKED';
